<ng-container rtBlock="sc-blog-image-block">
    @for (image of images(); track image.fileId) {
        <figure rtElem="figure">
            <img rtElem="img" decoding="async" loading="lazy" sizes="(width <= 860px) 100vw, 820px" [src]="image.imageUrl" [alt]="alt()" />
        </figure>
    }
</ng-container>
